import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { interval, Subscription } from 'rxjs';

interface NewsItem {
  guid: string;
  title: string;
  link: string;
  pubDate: string;
}

@Component({
  selector: 'app-latest-news',
  templateUrl: './latest-news.component.html',
  styleUrls: ['./latest-news.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class LatestNewsComponent implements OnInit, OnDestroy {
  newsItems: NewsItem[] = [];
  seenGuids = new Set<string>();
  isLoading = true;
  error = false;
  private subscription: Subscription = new Subscription();

  ngOnInit() {
    this.fetchRSSFeed();
    const intervalSub = interval(60000).subscribe(() => {
      this.fetchRSSFeed();
    });
    this.subscription.add(intervalSub);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  convertToNewYorkTimeOnly(gmtDateString: string): string {
    const date = new Date(gmtDateString);
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    }).format(date);
  }

  async fetchRSSFeed() {
    try {
      this.error = false;
      const FEED_URL = "https://www.financialjuice.com/feed.ashx?xy=rss";
      const proxy = "https://api.allorigins.win/get?url=" + encodeURIComponent(FEED_URL);
      
      const response = await fetch(proxy);
      const data = await response.json();
      
      const parser = new DOMParser();
      const xml = parser.parseFromString(data.contents, "text/xml");
      const items = xml.querySelectorAll("item");

      let newItems: NewsItem[] = [];
      items.forEach((item) => {
        const guid = item.querySelector("guid")?.textContent || null;
        if (!guid || this.seenGuids.has(guid)) return;

        let title = item.querySelector("title")?.textContent || "";
        title = title.replace(/^FinancialJuice:\s*/i, '');

        newItems.push({
          guid,
          title,
          link: item.querySelector("link")?.textContent || "",
          pubDate: item.querySelector("pubDate")?.textContent || "",
        });
      });

      if (newItems.length > 0) {
        newItems.forEach(item => this.seenGuids.add(item.guid));
        this.newsItems = [...newItems, ...this.newsItems].slice(0, 15);
      } else if (this.newsItems.length === 0 && !this.isLoading) {
        this.newsItems = [];
      }
      
      this.isLoading = false;
    } catch (error) {
      console.error('Error fetching RSS feed:', error);
      this.error = true;
      this.isLoading = false;
      
      if (this.newsItems.length === 0) {
        this.newsItems = [];
      }
    }
  }
}

